import React from "react";

import LocationAccess from "./components/LocationAccess";
import Profile from "./views/Patient/Profile";
import PaymentSuccessOrFailure from "./views/Patient/PaymentSuccessOrFailure";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  config,
  setIsLocationAccessOpen,
  setIsShowEditProfileModal,
} from "@/store/slices/config";
import { payment } from "./store/slices/patient/payment";

import {
  IAppointmentPaymentStatus,
  IPatientMemberDetailEnums,
} from "./models/patient";

const Overlays: React.FC = () => {
  const { isShowEditProfileModal, isLocationAccessOpen } =
    useAppSelector(config);
  const { isPaymentRedirected, paymentStatus } = useAppSelector(payment);
  const dispatch = useAppDispatch();
  return (
    <>
      {isLocationAccessOpen && (
        <LocationAccess
          isOpen={isLocationAccessOpen}
          closeHandler={() => dispatch(setIsLocationAccessOpen(false))}
        />
      )}
      {isShowEditProfileModal && (
        <Profile
          isOpen={isShowEditProfileModal}
          closeHandler={() => dispatch(setIsShowEditProfileModal(false))}
          type={IPatientMemberDetailEnums.GUEST_APPOINTMENT}
        />
      )}
      {isPaymentRedirected &&
        (paymentStatus === IAppointmentPaymentStatus.SUCCESS ||
          paymentStatus === IAppointmentPaymentStatus.FAILURE) && (
          <PaymentSuccessOrFailure />
        )}
    </>
  );
};

export default Overlays;
